const styleHook = 'data-highlighted';
export function addHighlight(ref) {
  ref.current?.setAttribute(styleHook, '');
}
export function removeHighlight(ref) {
  ref.current?.removeAttribute(styleHook);
}
export function hasHighlight(ref) {
  return ref.current?.hasAttribute(styleHook);
}